import axios from 'axios';

export const getAccountDetails = function(accountId, apiUrls) {
  return axios({
    method: 'get',
    url: `${apiUrls.account}?hashId=${accountId}`
  })
};
